import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getGiveawayById = async (id) => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/briefs/giveaways/${id}` });

  return data;
};

export default getGiveawayById;
